/* =============================================
   PECA CON ESTILO — Main JS
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  /* ---- Search toggle ---- */
  const searchToggle = document.getElementById('search-toggle');
  const headerSearch = document.getElementById('header-search');
  if (searchToggle && headerSearch) {
    searchToggle.addEventListener('click', () => {
      const isOpen = headerSearch.classList.toggle('is-open');
      headerSearch.setAttribute('aria-hidden', !isOpen);
      if (isOpen) headerSearch.querySelector('input')?.focus();
    });
  }

  /* ---- Mobile nav ---- */
  const menuToggle  = document.getElementById('menu-toggle');
  const menuClose   = document.getElementById('menu-close');
  const mobileNav   = document.getElementById('mobile-nav');
  const overlay     = document.getElementById('mobile-overlay');

  function openNav() {
    mobileNav?.classList.add('is-open');
    overlay?.classList.add('is-open');
    mobileNav?.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    mobileNav?.classList.remove('is-open');
    overlay?.classList.remove('is-open');
    mobileNav?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  menuToggle?.addEventListener('click', openNav);
  menuClose?.addEventListener('click', closeNav);
  overlay?.addEventListener('click', closeNav);

  /* ---- Header scroll shadow ---- */
  const header = document.getElementById('site-header');
  if (header) {
    const onScroll = () => {
      header.style.boxShadow = window.scrollY > 10
        ? '0 1px 12px rgba(26,26,26,0.07)'
        : 'none';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Quick add to cart ---- */
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const productId = btn.dataset.productId;
      if (!productId) return;
      await handleAddToCart(btn, btn, productId, 1);
    });
  });

  /* ---- Galería de producto ---- */
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const slides = document.querySelectorAll('.gallery-slide');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const idx = thumb.dataset.index;
      thumbs.forEach(t => t.classList.remove('is-active'));
      slides.forEach(s => s.classList.remove('is-active'));
      thumb.classList.add('is-active');
      document.querySelector(`.gallery-slide[data-index="${idx}"]`)?.classList.add('is-active');
    });
  });

  /* ---- Cantidad en producto ---- */
  const qtyInput  = document.getElementById('qty-input');
  const qtyMinus  = document.getElementById('qty-minus');
  const qtyPlus   = document.getElementById('qty-plus');
  if (qtyInput) {
    qtyMinus?.addEventListener('click', () => {
      const v = parseInt(qtyInput.value) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus?.addEventListener('click', () => {
      qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
    });
  }

  /* ---- Variantes de producto ---- */
  document.querySelectorAll('.option-swatch-input, .option-pill-input').forEach(input => {
    input.addEventListener('change', updateVariant);
  });
  async function updateVariant() {
    const form = document.getElementById('product-form');
    if (!form) return;
    const options = [];
    form.querySelectorAll('[name^="options"]').forEach(el => {
      if (el.type === 'radio' && el.checked) options.push(el.value);
      else if (el.type !== 'radio') options.push(el.value);
    });
    try {
      const handle = window.location.pathname.split('/products/')[1]?.split('?')[0];
      if (!handle) return;
      const res = await fetch(`/products/${handle}.js`);
      const data = await res.json();
      const variant = data.variants.find(v =>
        options.every((opt, i) => v[`option${i+1}`] === opt)
      );
      if (variant) {
        const idInput = document.getElementById('variant-id');
        if (idInput) idInput.value = variant.id;
        const priceEl = document.querySelector('.product-price');
        if (priceEl && variant.price) {
          priceEl.textContent = formatMoney(variant.price);
        }
        const addBtn = document.getElementById('add-to-cart');
        const addTxt = document.getElementById('add-to-cart-text');
        if (addBtn && addTxt) {
          addBtn.disabled = !variant.available;
          addTxt.textContent = variant.available ? 'Agregar al carro' : 'Agotado';
        }
      }
    } catch { /* silently fail */ }
  }
  function formatMoney(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CL');
  }

  /* ---- Agregar al carro (página de producto) ---- */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = document.getElementById('add-to-cart');
      const txt = document.getElementById('add-to-cart-text');
      if (!btn || !txt) return;
      const variantId = document.getElementById('variant-id')?.value;
      const qty = document.getElementById('qty-input')?.value || 1;
      if (!variantId) return;
      await handleAddToCart(btn, txt, variantId, parseInt(qty));
    });
  }

  async function handleAddToCart(buttonEl, textEl, id, quantity) {
    const originalText = textEl.textContent;
    textEl.textContent = 'Agregando...';
    buttonEl.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity })
      });
      if (res.ok) {
        textEl.textContent = '¡Agregado!';
        updateCartCount();
        setTimeout(() => { textEl.textContent = originalText; buttonEl.disabled = false; }, 2000);
      } else {
        throw new Error('Error al agregar');
      }
    } catch (err) {
      console.error("Cart Error:", err);
      textEl.textContent = originalText;
      buttonEl.disabled = false;
    }
  }

  /* ---- Carrito: qty controls ---- */
  document.querySelectorAll('.cart-qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = parseInt(btn.dataset.line);
      const action = btn.dataset.action;
      const input = document.querySelector(`.cart-qty-input[data-line="${line}"]`);
      if (!input) return;
      let qty = parseInt(input.value) || 1;
      if (action === 'decrease') qty = Math.max(0, qty - 1);
      else qty = qty + 1;
      input.value = qty;
      await updateCartLine(line, qty);
    });
  });
  document.querySelectorAll('.cart-qty-input').forEach(input => {
    input.addEventListener('change', async () => {
      const line = parseInt(input.dataset.line);
      const qty = Math.max(0, parseInt(input.value) || 0);
      await updateCartLine(line, qty);
    });
  });
  async function updateCartLine(line, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: qty })
      });
      if (res.ok) {
        const cart = await res.json();
        updateCartCount();
        const subtotal = document.getElementById('cart-subtotal');
        const total = document.getElementById('cart-total');
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
        if (total) total.textContent = formatMoney(cart.total_price);
        if (qty === 0) window.location.reload();
      }
    } catch { /* silently fail */ }
  }

  /* ---- Carrito: eliminar item ---- */
  document.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = parseInt(btn.dataset.line);
      await updateCartLine(line, 0);
    });
  });

  /* ---- Filtros mobile ---- */
  const filterToggle = document.getElementById('filter-toggle');
  const filterPanel  = document.getElementById('filter-panel');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', () => {
      const isOpen = filterPanel.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', isOpen);
      filterPanel.setAttribute('aria-hidden', !isOpen);
    });
  }

  /* ---- Sort select: auto-submit ---- */
  const sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEl = document.querySelector('.cart-count');
      if (cart.item_count > 0) {
        if (countEl) {
          countEl.textContent = cart.item_count;
        } else {
          const cartLink = document.querySelector('[aria-label="Carro de compras"]');
          if (cartLink) {
            const span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = cart.item_count;
            cartLink.appendChild(span);
          }
        }
      }
    } catch { /* silently fail */ }
  }

});
